function PendingIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 50 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={36.208}
        y={0.549}
        width={13.244}
        height={13.244}
        rx={1.097}
        stroke="#A7AEB7"
        strokeWidth={1.097}
      />
      <rect
        x={18.378}
        y={0.549}
        width={13.244}
        height={13.244}
        rx={1.097}
        stroke="#A7AEB7"
        strokeWidth={1.097}
      />
      <rect
        x={0.549}
        y={0.549}
        width={13.244}
        height={13.244}
        rx={1.097}
        stroke="#A7AEB7"
        strokeWidth={1.097}
      />
    </svg>
  )
}

export default PendingIcon
